const CarePlanUpsellCheckbox = [
    { span: 10, height: "69px", classes: "marginTop-8" },
    { span: 10, height: "1px", classes: "marginTop-16" },
    { span: 10, height: "21px", classes: "marginTop-16" },
]
export default CarePlanUpsellCheckbox
